/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
export const PERMISSION_CONSTANTS = {
  ADD_PROMOTION: 'apply-promotion',
  REMOVE_PROMOTION: 'remove_promotion',
  PRINT_MANAGEMENT_REPORTS: 'print-management-reports',
  UPDATE_STORE_ID: 'update_store_id',
  OPEN_CLOSE_STORE: 'open_close_store',
  REQUEST_REFUND: 'request_refund',
  BYPASS_VERIFICATION: '.bypass',
  IMEI_BLOCKING_TOOL_ACCESS: 'imei_blocking_tool_access',
  REMEDY_ACCESS_TOOL: 'remedy_access_tool',
  SHOW_GRAND_CENTRAL_ACCESS_LINK: 'show_grand_central_access_link',
  SHOW_FRAUD_ROUTING_FORM: 'show_fraud_routing_form',
  CREATE_CHARGE: 'CREATE_CHARGE',
  REQUEST_MISSING_PAYMENT: 'request_missing_payment',
  REQUEST_ADJUSTMENT: 'adjust',
  RETRIEVE_PUK_CODE: 'retrieve_puk_code',
  REQUEST_MSISDN_BLOCK: 'request_msisdn_block',
  RESET_CUSTOMER_TENURE: 'reset_customer_tenure',
  CREATE_SCORE_UPGRADE: 'create_score_upgrade',
  MANAGE_STORED_PAYMENT_METHODS: 'manage_stored_payment_methods',
  ACCEPT_DECIMAL_PRECISION: 'accept_decimal_precision',
  UPDATE_LOS_FAN_NICKNAMES: 'edit_nickname',
  UPDATE_PRIMARY_LINE_ASSIGNMENT: 'update_primary_line_assignment',
  MANAGE_BLOCKING_ROAMING: 'manage_blocking_roaming',
  GET_RATE_PLAN_HISTORY: 'line_msisdn_filter',
  RESUME_FROM_CANCEL: 'resume_from_cancel',
  UPDATE_CUSTOMER_PIN: 'update_customer_pin',
  ADD_TAX_EXEMPTION: 'add_tax_exemption',
  EDIT_SECURITY_QUESTIONS_PIN: 'edit_security_questions_pin',
  CREATE_AUTOPAY: 'create_autopay',
  CREATE_D2A: 'create_d2a',
  CANCEL_AUTOPAY: 'cancel_autopay',
  UPDATE_CASEMANAGEMENT_TICKET: 'update_casemanagement_ticket',
  OVERRIDE_DEFAULT_CANCELLINE_DATE: 'OVERRIDE_DEFAULT_CANCELLINE_DATE',
  OVERRIDE_INVENTORY_STATUS: 'override_inventory_status',
  BYPASS_REMORSE_RETURN_RESTR: 'BYPASS_REMORSE_RETURN_RESTR',
  BYPASS_DEVICE_EXCHANGE_ELIGIBILITY: 'BYPASS_DEVICE_EXCHANGE_ELIGIBILITY',
  OVERRIDE_DEVICE_IMEI_WARRANTY_EXG: 'OVERRIDE_DEVICE_IMEI_WARRANTY_EXG',
  OVERRIDE_DEVICE_DIAGNOSTICS_EVALUATION: 'OVERRIDE_DEVICE_DIAGNOSTICS_EVALUATION',
  UPDATE_ASSISTANCE_PROGRAM: 'UPDATE_ASSISTANCE_PROGRAM',
  UPDATE_ID_VERIFICATION: 'UPDATE_ID_VERIFICATION',
  UPDATE_SPECIAL_TREATMENT: 'UPDATE_SPECIAL_TREATMENT',
  UPDATE_TEST_INDICATOR: 'UPDATE_TEST_INDICATOR',
  UPDATE_CUSTOMER_GROUP: 'UPDATE_CUSTOMER_GROUP',
  OVERRIDE_MAX_CASH_REFUND_AMOUNT: 'override_max_cash_refund_amount',
  APPLY_CREDIT: 'Apply Credit',
  APPLY_CREDIT_LANDING: 'APPLY_CREDIT',
  ADJUST_CHARGES: 'adjust_charges',
  PENDING_CREDIT: 'pending_credits',
  OVERRIDE_PRICE_UP: 'override_price_up',
  OVERRIDE_PRICE_DOWN: 'override_price_down',
  VIEW_ORDER_RECEIPT: 'view_order_receipt',
  BYPASS_ENROLLMENT_WINDOW_RESTRICTIONS: 'bypass_enrollment_window_restrictions',
  OVERRIDE_DEFAULT_RATEPLAN_CHANGE_DATE: 'override_default_rateplan_change_date',
  ADD_IMEI_TO_BLACKLIST: 'add_imei_to_blacklist',
  REMOVE_IMEI_FROM_BLACKLIST: 'remove_imei_from_blacklist',
  BYPASS_PROMOTION_RESTRICTIONS: 'bypass_promotion_restrictions',
  BYPASS_DEVICE_DIAGNOSTIC_EXCHANGE_RETURN: 'bypass_device_diagnostic_exchange_return',
  CHANGE_RATE_PLAN: 'change_rate_plan',
  UPDATE_CUSTOMER_COMM_PREFERENCES: 'update_communication_preference',
  OVERRIDE_INELIGIBLE_RETURN: 'override_ineligible_return',
  REQUEST_REFUND_METHOD: 'request_refund_method',
  RESTORE_SUSPENDED_LOS: 'restore_suspended_los',
  CREATE_CASEMANAGEMENT_TICKET: 'create_casemanagement_ticket',
  ACCESS_GRANDFATHERED_OFFERS: 'access_grandfathered_offers',
  VIEW_SUBSCRIBER_ACCOUNT_ACTIVITY: 'view_subscriber_account_activity',
  VIEW_POST_VOID_TRANSACTIONS: 'view_post_void_transactions',
  WAIVE_SHIPPING_FEE: 'waive_shipping_fee',
  MODIFY_LOS_FEATURES: 'modify_los_features',
  NEGATIVE_FILE_REQUEST_ACCESS: 'negative_file_request_access',
  IMMEDIATE_DOWNGRADE: 'immediate_downgrade',
  LIFELINE: 'lifeline',
  LIFELINE_PR: 'lifeline_pr',
  CRM_DISCOUNTS: 'crm_discounts',
  SUPER_USERS: 'super_users',
  GENCARE_RETAILMANAGER: 'gencare_retailmanager',
  VIEW_POS_REPORTS: 'view_pos_reports',
  ACCESS_RETAIL: 'access_retail',
  ACCESS_CARE: 'access_care',
  MSISDN_CHANGE: 'msisdn_change',
  ADD_A_LINE: 'ADD_A_LINE',
  CHANGE_RTPLN_LOST_STOLEN: 'change_rtpln_lost_stolen',
  UPDATE_ADDRESS: 'update_address',
  CREATE_FRAUD_MEMO: 'create_fraud_memo',
  IMEI_BLOCK: 'imei_block',
  IMEI_UNBLOCK: 'imei_unblock',
  IMEI_ADD_BLOCK: '/imei-check',
  IMEI_ADD_BLOCK_ABF: 'imei_block',
  IMEI_BLOCKING_TOOL: '/repDashboard',
  IMEI_BLOCKING_TOOL_ABF: 'imei_blocking_tool',
  PERMISSION_ENABLE: 'Enable',
  PERMISSION_DISABLE: 'Disable',
  WAIVE_SSK: 'waive_ssk',
  SUBMIT_AUTOREQ_FOR_D2A_EPIN: 'submit_autoreq_for_d2a_epin',
  SUBMIT_MANUALREQ_FOR_D2A_EPIN: 'submit_manualreq_for_d2a_epin',
  UPDATE_ORDER_SHIPPING_TO_NAME: 'update_order_shipping_to_name',
  PURCHASE_SESSION_PASSES: 'purchase_session_passes',
  REP_PERMISSION_TYPE: 'RepOnly',
  ACTIVATION: 'activation',
  BROWSE_PHONES: '/browse-plans-phone',
  PLAN_DETAIL: '/plan-details',
  BYOD: '/bring-your-own-device',
  LINE_SETUP: '/cart/line-setup',
  REVIEW_CART: '/cart/review',
  DEVICE_PDP: '/productDetails',
  PRODUCT_SELECTOR: '/product-selector',
  RETURN_PAYMENT_DISPUTE: 'return_payment_dispute',
  ORDER_DEVICE: 'ORDER_DEVICE',
  PRE_ORDER_DEVICE: 'PRE_ORDER_DEVICE',
  CHANGE_SIM: 'CHANGE_SIM',
  REMOVE_IMEI_BLACKLIST: 'REMOVE_IMEI_FROM_BLACKLIST',
  EDIT_SPECIAL_INSTRUCTIONS: 'EDIT_SPECIAL_INSTRUCTIONS',
  CHANGE_LANGUAGE_PREFERENCE: 'CHANGE_LANGUAGE_PREFERENCE',
  UPDATE_ACCOUNT_SEGMENTATION: 'UPDATE_ACCOUNT_SEGMENTATION',
  UPDATE_CUSTOMER_SEGMENTATION: 'UPDATE_CUSTOMER_SEGMENTATION',
  EDIT_BILLING_ADDRESS: 'EDIT_BILLING_ADDRESS',
  EDIT_PPU_ADDRESS: 'EDIT_PPU_ADDRESS',
  REFILL_EPIN: 'REFILL_EPIN',
  ORDER_ACCESSORY: 'ORDER_ACCESSORY',
  MANAGE_UNLOCK: 'MANAGE_UNLOCK',
  REVERSE_CREDIT: 'REVERSE_CREDIT',
  REVERSE_ADJUSTMENT: 'REVERSE_ADJUSTMENT',
  PAYMENT_TRANSFER: 'PAYMENT_TRANSFER',
  DEVICE_EXCHANGE: 'DEVICE_EXCHANGE',
  UPDATE_CUSTOMER_PROF: 'UPDATE_CUSTOMER_PROF',
  UPDATE_CUSTOMER_NAME: 'UPDATE_CUSTOMER_NAME',
  UPDATE_CUSTOMER_PASSWORD: 'UPDATE_CUSTOMER_PASS',
  ACCOUNT_SETUP: '/cart/account-setup',
  REMOVE_PORT_PROTECTION_ABF: 'REMOVE_PORT_PROTECTION',
  OTP_VERIFICATION: 'otp_verification',
  BYPASS_ONE_TIME_PIN: 'BYPASS_ONE_TIME_PIN',
  OTP_MANAGER_OVERRIDE: 'OTP_MANAGER_OVERRIDE',
  SIM_PROTECTION: 'SIM_PROTECTION',
};
